import { render, staticRenderFns } from "./modalMensaje.vue?vue&type=template&id=5d984fde&"
import script from "./modalMensaje.vue?vue&type=script&lang=js&"
export * from "./modalMensaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports